<div class="i-page-top">
  <div class="container">
    <!--Menu-->
    <div class="i-menu row align-items-center pt-3 pb-2">
      <div class="navbar-brand col-6 col-sm-8 col-md-6 col-lg-4 mr-auto py-2 px-0 text-center text-sm-left">
        <a href="#" routerLink="/home" aria-label="Private"
          ><img src="assets/img/logo_cinza.svg" class="img-fluid my-auto" alt="Private"
        /></a>
      </div>
      <div class="col-6 col-sm-4 col-md-6 col-lg-8 ml-auto py-2">
        <app-menu></app-menu>
      </div>
    </div>
  </div>
</div>
<div class="i-page-content">
  <div class="i-favorite container py-5">
    <div class="row text-center py-3">
      <h1 class="i-title mx-auto">POLÍTICA DE PRIVACIDADE</h1>
    </div>
    <div class="row">
      <div class="col-10 offset-1">
        <p>
          Nós, da PRIVATE INVESTIMENTOS IMOBILIÁRIOS LTDA. (“PRIVATE”, “Empresa” ou “nós”), uma das maiores empresas do
          setor imobiliário gaúcho, inscrita no CNPJ/ME sob o n. 12.076.845/0001-40 e com sede na Cidade de Porto
          Alegre, Estado do Rio Grande do Sul, Rua 24 de outubro, 1440, sala 1605, CEP 90510-001, levamos a sua
          privacidade e a proteção dos seus dados a sério. Este documento explica como tratamos seus dados pessoais,
          quais são os seus direitos e como você pode exercê-los.<br />
        </p>
        <div class="border my-4 p-4">
          <b>Por que a PRIVATE trata seus dados pessoais?</b><br />
          Todo e qualquer dado pessoal tratado através do site www.privateimoveis.com é utilizado pela Empresa para
          viabilizar o fornecimento de maiores informações acerca de produtos ou serviços ofertados através do website;
          para buscar a identificação do perfil, desejos e necessidades de cada usuário, a fim de aprimorar a oferta de
          imóveis e os serviços de corretagem imobiliária prestados pela PRIVATE; bem como para personalizar a
          experiência online do usuário.<br /><br />
          O seu endereço de e-mail e/ou o seu telefone celular servem como identificadores únicos do nosso sistema de
          registro, e juntamente com sua senha, foi designado para prevenir o acesso não autorizado a quaisquer
          informações que você escolheu armazenar no site da PRIVATE.<br /><br />
          Os dados que você nos fornece sobre suas preferências pessoais e demográficas podem ser usados para nos
          auxiliar a oferecer conteúdo, propagandas, produtos e serviços que acreditamos ser interessantes para você.<br />
        </div>
        <p>
          <b>1. CONCEITOS BÁSICOS: O QUE VOCÊ PRECISA SABER PARA COMPREENDER ESTA POLÍTICA?</b><br />
          A fim de descomplicar a sua leitura deste documento, apresentamos algumas definições úteis para a sua
          interpretação:<br />
        </p>
        <div class="table-responsive">
          <table class="table table-bordered">
            <tr>
              <th>Termo</th>
              <th>Conceito</th>
            </tr>
            <tr>
              <td>Dado Pessoal</td>
              <td>
                É uma informação relacionada a uma pessoa física e que seja capaz de identificar a pessoa ou tornar
                possível a sua identificação.<br />
                São exemplos de dados pessoais que podem permitir a sua identificação: Nome, CPF, telefone, e-mail,
                endereço de IP, etc.
              </td>
            </tr>
            <tr>
              <td>Tratamento</td>
              <td>
                É toda forma de uso que podemos fazer dos seus Dados Pessoais, incluindo, mas não se limitando às
                seguintes atividades: coleta, armazenamento, consulta, uso, compartilhamento, transmissão,
                classificação, reprodução, exclusão e avaliação.
              </td>
            </tr>
            <tr>
              <td>Titular</td>
              <td>É você, a pessoa física a quem os Dados Pessoais se referem.</td>
            </tr>
            <tr>
              <td>Empresa</td>
              <td>Somos nós, a PRIVATE INVESTIMENTOS IMOBILIÁRIOS LTDA.</td>
            </tr>
            <tr>
              <td>Política</td>
              <td>É esta Política de Privacidade.</td>
            </tr>
          </table>
        </div>
        <p>
          <b>2. QUE TIPOS DE DADOS PESSOAIS A PRIVATE TRATA?</b><br />
          Os tipos de Dados Pessoais e a forma como a Empresa os coleta dependem de como você se relaciona com a Empresa
          e por quê.<br />
          Listamos abaixo algumas situações em que nós podemos tratar seus Dados Pessoais no contexto da sua relação com
          a Empresa:<br />
        </p>
        <div class="table-responsive">
          <table class="table table-bordered">
            <tr>
              <th>Origem</th>
              <th>Finalidade</th>
              <th>Tipos de Dados Pessoais Utilizados</th>
            </tr>
            <tr>
              <td>WHATSAPP</td>
              <td>
                Prestar atendimento ao usuário, auxiliando o mesmo na busca pelo imóvel, bem como inseri- lo dentro do
                banco de dados da empresa, para que ele possa ser atingido por campanhas de marketing.
              </td>
              <td>Nome, e-mail, telefone</td>
            </tr>
            <tr>
              <td>CHATBOT</td>
              <td>
                Prestar atendimento através do chatbot, auxiliando o mesmo na busca pelo imóvel, bem como inseri-lo
                dentro do banco de dados da empresa, para que ele possa ser atingido por campanhas de marketing.
              </td>
              <td>Nome, telefone e e-mail, URL data e hora da navegação</td>
            </tr>
            <tr>
              <td>CADASTRO LOGIN USUÁRIO</td>
              <td>
                Fornecer mais ferramentas de busca ao usuário, bem como inseri-lo dentro do banco de dados da empresa,
                para que ele possa ser atingido por campanhas de marketing.
              </td>
              <td>Nome, e-mail, telefone, e senha.</td>
            </tr>
            <tr>
              <td>NAVEGAÇÃO DO USUÁRIO LOGADO</td>
              <td>
                Permitir que o usuário navegue no catálogo de imóveis da Private possibilitando marcar imóveis como
                favoritos ou descartados (que não serão apresentados nas listas) e permitindo sua comparação com outros
                imóveis. Identificar imóveis mais acessados por determinado perfil de usuário autenticado.
              </td>
              <td>Preferência de navegação e de acordo com perfil (Região através de DDD e IP).</td>
            </tr>
            <tr>
              <td>NEWSLETTER</td>
              <td>Divulgar conteúdos relevantes e de interesse dos usuários cadastrados na newsletter.</td>
              <td>Nome e e-mail</td>
            </tr>
            <tr>
              <td>FORMULÁRIO CONTATO GERAL</td>
              <td>
                Oportunizar o atendimento especializado pelos corretores autônomos parceiros da PRIVATE, auxiliando o
                mesmo na busca pelo imóvel, bem como inseri-lo dentro do banco de dados da empresa, para que ele possa
                ser atingido por campanhas de marketing.
              </td>
              <td>Nome, e-mail e telefone, cidade e estado</td>
            </tr>
            <tr>
              <td>FORMULÁRIO CONTATO IMÓVEL ESPECÍFICO</td>
              <td>
                Oportunizar o atendimento especializado pelos corretores autônomos parceiros da PRIVATE objetivando e
                permitindo o agendamento de visita no imóvel.
              </td>
              <td>Nome, e-mail, telefone, data e horário de preferência da visita.</td>
            </tr>
            <tr>
              <td>FORMULÁRIO TRABALHE CONOSCO</td>
              <td>
                Possibilitar o cadastro de usuários interessados em participar dos processos seletivos da PRIVATE.
              </td>
              <td>Nome, e-mail, telefone, estado, perfil do Instagram e perfil do LinkedIn.</td>
            </tr>
            <tr>
              <td>BLOG</td>
              <td>
                Divulgação de matérias e notícias relativas ao meio imobiliário ou aos imóveis e serviços
                prestados/oferecidos pela Private.
              </td>
              <td>Nome e e-mail</td>
            </tr>
          </table>
        </div>
        <p>
          <b>3. O QUE SÃO COOKIES E COMO SÃO UTILIZADOS NO SITE DA PRIVATE?</b><br />
          Como é prática comum em quase todos os sites profissionais, este site usa cookies, que são pequenos arquivos
          baixados no seu computador, para melhorar sua experiência. No quadro abaixo descrevemos quais informações eles
          coletam, como as usamos e por que às vezes precisamos armazenar esses cookies. Também compartilharemos como
          você pode impedir que esses cookies sejam armazenados, no entanto, isso pode fazer o downgrade ou ’quebrar’
          certos elementos da funcionalidade do site. Utilizamos cookies por vários motivos, detalhados abaixo.
          Infelizmente, na maioria dos casos, não existem opções padrão do setor para desativar os cookies sem desativar
          completamente a funcionalidade e os recursos que eles adicionam a este site.<br />
          Listamos abaixo alguns dos cookies utilizados pela Empresa e suas respectivas funcionalidades:<br />
        </p>
        <div class="table-responsive">
          <table class="table table-bordered">
            <tr>
              <th>Cookie</th>
              <th>Funcionalidade</th>
            </tr>
            <tr>
              <td>PRIVATE (necessário)</td>
              <td>
                O Cookie da PRIVATE serve para manutenção dos parâmetros de login do usuário, bem como para vinculação
                do usuário ao corretor autônomo parceiro que realiza o seu atendimento.
              </td>
            </tr>
            <tr>
              <td>Rocket.chat (necessário)</td>
              <td>O Rocket.chat é uma ferramenta para atendimento do usuário em livechat.</td>
            </tr>
            <tr>
              <td>Google Tag Manager (necessário)</td>
              <td>
                O Google Tag Manager é uma ferramenta que permite gerenciar e rastrear as conversões oriundas de
                campanhas em plataformas parceiras. Leia mais em: link
              </td>
            </tr>
            <tr>
              <td>Google Analytics (necessário)</td>
              <td>
                O Google Analytics é uma ferramenta que permite analisar o comportamento/ engajamento dos usuários em um
                site/ app que coleta cookies primários, dados relacionados ao dispositivo/ navegador, o endereço IP e as
                atividades no site/app para avaliar e coletar estatísticas sobre as interações dos usuários nos sites
                e/ou aplicativos que o utilizam. Leia mais em: https://
                support.google.com/analytics/answer/6004245?hl=pt-BR
              </td>
            </tr>
            <tr>
              <td>Google Ads (propaganda)</td>
              <td>
                O Google Ads é a ferramenta de mídia do Google. Os cookies de publicidade do Google são coletados e
                utilizados para ativar funcionalidades como o remarketing na rede de display e pesquisa do Google. Leia
                mais em: https://policies.google.com/technologies/ads?hl=pt-BR&hl=pt_BR
              </td>
            </tr>
            <tr>
              <td>Facebook Ads (propaganda)</td>
              <td>
                O Facebook Ads é a ferramenta de mídia do Facebook. Os cookies de publicidade do facebook são coletados
                e utilizados para ativar funcionalidades como o remarketing dentro da plataforma da rede social. Leia
                mais em: https://www.facebook.com/policy/cookies/
              </td>
            </tr>
            <tr>
              <td>Vars.hotjar (opcional)</td>
              <td>
                O Vars.hotjar é uma ferramenta de análise e melhoramento da experiência do usuário no site, bem como de
                pesquisa satisfação (NPS) em relação ao conteúdo de navegação. Leia mais em:
                https://www.hotjar.com/legal/policies/privacy/
              </td>
            </tr>
            <tr>
              <td>Criteo (opcional)</td>
              <td>
                A Criteo é a ferramenta de remarketing. Os cookies de publicidade são coletados e utilizados para ativar
                funcionalidades de remarketing dentro dos espaços destinados a esta prática. Leia mais em: Leia mais em:
                https://www.criteo.com/br/privacy/
              </td>
            </tr>
          </table>
        </div>
        <p>
          <b>Como desativar os cookies?</b><br />
          A maioria dos navegadores é configurada para aceitar automaticamente os cookies. Mas você pode alterar as
          configurações para bloquear cookies ou alertá-lo quando um cookie estiver sendo enviado ao seu dispositivo.
          Existem várias formas de gerenciar cookies, sendo possível criar um bloqueio geral para cookies, bloquear
          cookies de um site específico e até mesmo bloquear cookies de terceiros em relação a um site. Bloquear todos
          os cookies vai afetar o funcionamento da sua experiência, pois não será possível identificar suas preferências
          e recomendar conteúdo e publicidade relevantes. Consulte as instruções do seu navegador para saber mais sobre
          como ajustar ou alterar suas configurações, lembrando que a configuração desejada deve ser replicada em todos
          os dispositivos utilizados para acessar os Serviços (como computadores, smartphones, tablets).<br />
          Abaixo os links para alterar a configuração de cookies nos principais navegadores:<br />
          <br />
          Internet Explorer:
          https://support.microsoft.com/pt-br/topic/excluir-e-gerenciar-cookies-168dab11-0753-043d-7c16-ede5947fc64d<br />
          <br />
          Edge: https://support.microsoft.com/pt-br/help/4468242/microsoft-edge-browsing-data-and-privacy<br />
          <br />
          Chrome: https://support.google.com/chrome/answer/95647?hl=pt-BR<br />
          <br />
          Safari: https://support.apple.com/pt-br/guide/safari/sfri11471/mac<br />
          <br />
          Firefox:
          https://support.mozilla.org/pt-BR/kb/protecao-aprimorada-contra-rastreamento-firefox-desktop?redirectslug=ative-e-desative-os-cookies-que-os-sites-usam&redirectlocale=pt-BR<br />
          <br />
          Opera: https://help.opera.com/en/latest/web-preferences/<br />
        </p>
        <p>
          <b>4. COM QUEM A PRIVATE COMPARTILHA OS SEUS DADOS PESSOAIS?</b><br />
          Nós operamos em parceria com uma série de outras organizações para viabilizar as nossas atividades. Sendo
          assim, podemos compartilhar alguns dados pessoais de nossos usuários com nossos Parceiros e Fornecedores tais
          como Isul Tecnologia, Wavemaker, Leadster, CRM Vista, RD Station, Google Ads, Facebook, Portais de forma
          anônima, sempre que possível ou exigido por lei.<br />
        </p>
        <p>
          <b>5. QUAIS SÃO OS SEUS DIREITOS COMO TITULAR DE DADOS PESSOAIS?</b><br />
          Os Dados Pessoais são seus e a lei brasileira lhe garante uma série de direitos relacionados a eles. Nós
          estamos comprometidos com o cumprimento desses direitos e, nessa seção, vamos explicar quais são esses
          direitos e como você pode exercê-los. Veja a seguir:<br />
        </p>
        <div class="table-responsive">
          <table class="table table-bordered">
            <tr>
              <th>Seus Direitos</th>
              <th>Explicação</th>
            </tr>
            <tr>
              <td>Confirmação e Acesso</td>
              <td>
                Você pode solicitar à Empresa a confirmação sobre a existência de tratamento dos seus Dados Pessoais
                para que, em caso positivo, você possa acessá-los, inclusive por meio de solicitação de cópias dos
                registros que temos sobre você.
              </td>
            </tr>
            <tr>
              <td>Correção</td>
              <td>
                Você pode solicitar a correção dos seus Dados Pessoais caso estes estejam incompletos, inexatos ou
                desatualizados.
              </td>
            </tr>
            <tr>
              <td>Anonimização, bloqueio ou eliminação</td>
              <td>
                Você pode solicitar (a) a anonimização dos seus Dados Pessoais, de forma que eles não possam mais ser
                relacionados a você e, portanto, deixem de ser Dados Pessoais; (b) o bloqueio dos seus Dados Pessoais,
                suspendendo temporariamente a sua possibilidade de os tratarmos para certas finalidades; e (c) a
                eliminação dos seus Dados Pessoais, caso em que deveremos apagar todos os seus Dados Pessoais sem
                possibilidade de reversão.
              </td>
            </tr>
            <tr>
              <td>Portabilidade</td>
              <td>
                Você pode solicitar que a Empresa forneça os seus Dados Pessoais em formato estruturado e interoperável
                visando à sua transferência para um terceiro, desde que essa transferência não viole a propriedade
                intelectual ou segredo de negócios da Empresa.
              </td>
            </tr>
            <tr>
              <td>Informação sobre o compartilhamento</td>
              <td>
                Você tem o direito de saber quais são as entidades públicas e privadas com as quais a Empresa realiza
                uso compartilhado dos seus Dados Pessoais. Manteremos, no item 3 dessa Política, uma indicação das
                nossas relações com terceiros que podem envolver o compartilhamento de Dados Pessoais. Em todo caso, se
                você tiver dúvidas ou quiser mais detalhes, você tem o direito de nos solicitar essas informações. A
                depender do caso, podemos limitar as informações fornecidas a você caso a sua divulgação possa violar a
                propriedade intelectual ou segredo de negócios da Empresa.
              </td>
            </tr>
            <tr>
              <td>Informação sobre a possibilidade de não consentir</td>
              <td>
                Você tem o direito de receber informações claras e completas sobre a possibilidade e as consequências de
                não fornecer consentimento, quando ele for solicitado pela Empresa. O seu consentimento, quando
                necessário, deve ser livre e informado. Portanto, sempre que pedirmos seu consentimento, você será livre
                para negá-lo – nesses casos, é possível que alguns serviços não possam ser prestados.
              </td>
            </tr>
            <tr>
              <td>Revogação do consentimento</td>
              <td>
                Caso você tenha consentido com alguma finalidade de tratamento dos seus Dados Pessoais, você pode sempre
                optar por retirar o seu consentimento. No entanto, isso não afetará a legalidade de qualquer Tratamento
                realizado anteriormente à revogação. Se você retirar o seu consentimento, é possível que fiquemos
                impossibilitados de lhe prestar certos serviços, mas iremos avisá-lo quando isso ocorrer.
              </td>
            </tr>
            <tr>
              <td>Oposição</td>
              <td>
                A lei autoriza o tratamento de Dados Pessoais mesmo sem o seu consentimento ou um contrato conosco.
                Nessas situações, somente trataremos seus Dados Pessoais se tivermos motivos legítimos para tanto, como,
                por exemplo, quando for necessário para garantir a segurança de nossas rodovias. Caso você não concorde
                com alguma finalidade de tratamento dos seus Dados Pessoais, você poderá apresentar oposição,
                solicitando a sua interrupção.
              </td>
            </tr>
          </table>
        </div>
        <p>
          <b>AVISOS IMPORTANTES</b><br />
          Para sua segurança, sempre que você apresentar uma requisição para exercer seus direitos, a Empresa poderá
          solicitar algumas informações e/ou documentos complementares para que possamos comprovar a sua identidade,
          buscando impedir fraudes. Fazemos isso para garantir a segurança e a privacidade de todos.<br />
          Em alguns casos, a Empresa pode ter motivos legítimos para deixar de atender a uma solicitação de exercício de
          direitos. Essas situações incluem, por exemplo, casos em que uma revelação de informações específicas poderia
          violar direitos de propriedade intelectual ou segredos de negócio da Empresa ou de terceiros, bem como casos
          em que pedidos de exclusão de dados não possam ser atendidos em razão da existência de obrigação da Empresa de
          reter dados, seja para cumprir obrigações legais, regulatórias ou para possibilitar a defesa da Empresa ou de
          terceiros em disputas de qualquer natureza.<br />
          Ainda, algumas solicitações podem não ser respondidas de forma imediata, mas a Empresa se compromete a
          responder todas as requisições em um prazo razoável e sempre em conformidade com a legislação aplicável.<br />
          Caso você tenha alguma dúvida sobre essas questões ou sobre como você pode exercer seus direitos, fique à
          vontade para entrar em contato conosco por meio dos canais informados ao final desta Política.<br />
        </p>
        <p>
          <b>6. POR QUANTO TEMPO OS DADOS PESSOAIS SERÃO ARMAZENADOS?</b><br />
          A Empresa possui uma política de retenção de Dados Pessoais alinhada com a lei aplicável. Dados Pessoais são
          armazenados somente pelo tempo que forem necessários para cumprir com as finalidades para as quais foram
          coletados, salvo se houver qualquer outra razão para sua manutenção como, por exemplo, cumprimento de
          quaisquer obrigações legais, regulatórias, contratuais, entre outras permitidas sob a lei.<br />
          Sempre fazemos uma análise técnica para determinar o período de retenção adequado para cada tipo de Dado
          Pessoal coletado, considerando a sua natureza, necessidade de coleta e finalidade para a qual ele será
          tratado, bem como eventuais necessidades de retenção para o cumprimento de obrigações ou o resguardo de
          direitos.<br />
        </p>
        <p>
          <b>7. COMO A PRIVATE PROTEGE SEUS DADOS PESSOAIS?</b><br />
          Nossa responsabilidade é cuidar dos seus Dados Pessoais e utilizá-los somente para as finalidades descritas
          nessa Política. Para garantir a sua privacidade e a proteção dos seus Dados Pessoais, adotamos recursos
          tecnológicos avançados para garantir a segurança de todos os dados tratados pela Empresa. Entre as medidas de
          segurança implementadas estão a implementação de controles de acesso a sistemas e ambientes de tratamento de
          dados, técnicas de criptografia e a instalação de barreiras contra o acesso indevido às bases de dados
          (incluindo firewalls), entre outros controles de segurança da informação.<br />
          Nós nos esforçamos para proteger a privacidade de seus Dados Pessoais, mas infelizmente não podemos garantir
          total segurança. Entradas e usos não autorizados de terceiros com informações suas, falhas de hardware ou
          software que não estejam sob controle da Empresa e outros fatores externos podem comprometer a segurança dos
          seus Dados Pessoais. Por isso, sua atuação é fundamental para a manutenção de um ambiente seguro para todos.
          Caso você identifique ou tome conhecimento de qualquer fator que comprometa a segurança dos seus dados na sua
          relação com a Empresa, por favor entre em contato conosco por meio das informações de contato indicadas
          abaixo.<br />
        </p>
        <p>
          <b>8. COMO FALAR SOBRE DADOS PESSOAIS COM A PRIVATE?</b><br />
          Se você acredita que seus Dados Pessoais foram tratados de maneira incompatível com esta Política ou com as
          suas escolhas enquanto Titular dos seus Dados Pessoais, ou, ainda, se você tiver dúvidas, comentários ou
          sugestões relacionadas a esta Política e à forma como tratamos seus Dados Pessoais, entre em contato conosco.
          Nós temos um Encarregado que está à disposição nos seguintes endereços de contato:<br />
        </p>
        <div class="border my-4 p-4">
          Encarregado: Letícia Assis <br />
          Endereço para correspondências:<br />
          Rua 24 de outubro, 1440, sala 1605, Porto Alegre,<br />
          CEP 90510-001<br />
          E-mail para contato: encarregadolgpd&#64;private.com.br
        </div>
        <p>
          <b>9. MUDANÇAS NA POLÍTICA DE PRIVACIDADE</b><br />
          Como estamos sempre buscando melhorar os nossos serviços e a forma como operamos, esta Política de Privacidade
          pode passar por atualizações para refletir as melhorias realizadas. Desta forma, recomendamos a visita
          periódica desta página para que você tenha conhecimento sobre as modificações efetivadas.<br /><br />
          DATA DA ÚLTIMA ATUALIZAÇÃO: 24 de junho de 2021.<br /><br />
          Histórico de versões:<br />
          V1<br />
        </p>
      </div>
    </div>
  </div>
</div>
